import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    Alert,
    FormControl,
    TextField,
    Select,
    MenuItem
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { EditIcon } from '../../../vectors/index';
import Add from '@mui/icons-material/Add';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEditTemplate } from '../hooks/useEditTemplate';
import { EnterpriseTemplate } from '../types';

type EditTemplateModalProps = {
    item: EnterpriseTemplate;
    handleClose: () => void;
};

const schema = yup.object({
    templateName: yup.string().required('Name is required'),
    templateDescription: yup.string().required('Description is required'),
    // status: yup.number().required('Status is required'), // Optional validation
}).required();

const EditTemplateModal: FC<EditTemplateModalProps> = ({ handleClose, item }) => {
    const [errorText, setErrorText] = useState<string>('');

    const { editTemplate, isUpdatingTemplate } = useEditTemplate({ setErrorText });

    const { control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });

    const handleAdd = (data: { templateName: string; templateDescription: string }) => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message);
                handleClose();
            },
        };

        editTemplate({
            name: data.templateName,
            description: data.templateDescription,
            template_id: item.id,
            // status: data.status
        }, options);

    };

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <br />
                <EditIcon />
                <br />
                <Typography variant="h4" >
                    Edit Template
                </Typography>
            </DialogTitle>
            <DialogContent>
                {errorText && <Alert sx={{ margin: "10px 0" }} severity="error">{errorText}</Alert>}
                <form onSubmit={handleSubmit(handleAdd)}>
                    <FormControl sx={{ marginBottom: "10px" }} fullWidth>
                        <Typography id="pay-rate-type-label"> Name</Typography>
                        <Controller
                            name="templateName"
                            control={control}
                            defaultValue={item.name}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    size='small'
                                    variant="outlined"
                                    error={!!errors.templateName}
                                    helperText={errors.templateName?.message}
                                    fullWidth
                                />
                            )}
                        />
                    </FormControl>
                    <FormControl sx={{ marginBottom: "10px" }} fullWidth>
                        <Typography id="pay-rate-type-label"> Description</Typography>
                        <Controller
                            name="templateDescription"
                            control={control}
                            defaultValue={item.description}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    size='small'
                                    variant="outlined"
                                    error={!!errors.templateDescription}
                                    helperText={errors.templateDescription?.message}
                                    fullWidth
                                    multiline
                                    rows={4}
                                    maxRows={4}
                                />
                            )}
                        />
                    </FormControl>
                    {/* <FormControl sx={{ marginBottom: "10px" }} fullWidth>
                        <Typography id="status-label">Status</Typography>
                        <Controller
                            name="status"
                            control={control}
                            defaultValue={item.status}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    size="small"
                                    variant="outlined"
                                    error={!!errors.status}
                                    fullWidth
                                    MenuProps={{ PaperProps: { style: { borderRadius: 5 } } }}
                                >
                                    <MenuItem value={0}>Active</MenuItem>
                                    <MenuItem value={1}>Archive</MenuItem>
                                </Select>
                            )}
                        />
                    </FormControl> */}
                    <LoadingButton
                        loading={isUpdatingTemplate}
                        disabled={isUpdatingTemplate}
                        fullWidth
                        startIcon={<Add />}
                        variant="contained"
                        color="primary"
                        type="submit"
                    >
                        Save Template
                    </LoadingButton>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default EditTemplateModal;
